import React from 'react';
import { BaseButton, useIsMobile, useT } from '@repo/common';

const PersonalInfoText = ({ isEditing, onEditClick }) => {
  const isMobile = useIsMobile();
  const t = useT();

  return (
    <div className='flex tabletH:max-w-[568px] w-full tabletH:pb-6 justify-between items-center'>
      <div className='flex flex-col gap-2'>
        <div className='flex text-center items-center gap-2 h-[30px]'>
          <div className='flex items-center text-center mt-1 typo-b18Strong tabletH:typo-title1 text-text-primary'>
            {t('Personal Info', '개인 정보')}
          </div>
          {!isEditing && !isMobile && (
            <BaseButton size='s' hideIcon width='90px' onClick={onEditClick}>
              {t('Edit Profile', '프로필 수정')}
            </BaseButton>
          )}
        </div>
        <div className='typo-b11 tabletH:typo-b14 text-text-placeholder'>
          {t(
            'Your profile may be visible to companies when you apply for jobs and to other users as part of your social profile on Koready.',
            '채용 공고에 지원할 때 기업에, 그리고 Koready 소셜 프로필의 일부로 다른 사용자에게 회원님의 프로필이 표시될 수 있습니다.',
          )}
        </div>
      </div>
    </div>
  );
};

export default PersonalInfoText;
